<!--Spinner-->
@if (showSpinner) {
  <div class="overlay">
    <div cbPageSpinner colorTheme="default" sizeVariant="large">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>
}
<div class="container">
  <div class="steps-container">
    <section class="steps-sections__progress-bar">
      <app-progress-bar></app-progress-bar>
    </section>
    <section class="steps-sections bottom-spacer">
      <div class="job-type-content">
        <p class="title">WORKERS’ COMPENSATION
          <!-- <span class="skip" *ngIf="showSkipPolicyLink" (click)="handleSkipPolicy()">Skip</span> -->
        </p>
        <p class="subtitle color_gh">
          Tell us a little more
        </p>

        @if (!isUserAgent) {
          <p class="text">Please identify all owners/officers and employees in your organization.
            <a class="stateguidelines" (click)="stateGuidelines()"> (See state statutory guidelines)</a>
          </p>
        }
        @if (isUserAgent) {
          <p class="text">Please identify all owners/officers and employees in the organization.
            <a class="stateguidelines" (click)="stateGuidelines()"> (See state statutory guidelines)</a>
          </p>
        }

        <div class="choose-one-both">
          @if (showOfficersCheckBox) {
            <div class="warning-container">
              <span class="warning backgroundg1">!</span><p class="choose-text">Choose one or both:</p>
            </div>
          }

          <!--*ngIf="entityTypeValues?.allowInclude"-->
          @if (entityTypeValues?.allowInclude && showOfficersCheckBox) {
            <div class="check-includeOfficers">
              @if (isUserAgent) {
                <mat-checkbox [formControl]="includeOfficers"
                  (change)="showBlock(includeOfficers, 'include', commonCommunicationService.empLimits)">
                  I have Owners/Officers that will be <b>included</b> in the Workers Compensation policy.
                </mat-checkbox>
              }
              @if (!isUserAgent) {
                <mat-checkbox [formControl]="includeOfficers"
                  (change)="showBlock(includeOfficers, 'include', commonCommunicationService.empLimits)">
                  I have Owners/Officers that will be <b>included</b> in my Workers Compensation policy.
                </mat-checkbox>
              }
            </div>
          }

          @if (formviewState?.includeBlock?.isAdded) {
            <div>
              @for (tile of formviewState.includeBlock.tiles; track tile; let i = $index) {
                <div class="tile-wrapper">
                  @if (companyStructure && execTitles) {
                    <div>
                      <app-emp-tile [blockDetails]="tile" [type]="'include'"
                        [companyStructure]="entityTypeValues.includeEntities" [state]="state" [errorMessages]="errorMessages"
                        [id]="'include'+i" [viewIndex]="i" [isIncludeAdded]="formviewState.includeBlock.isAdded"
                        [length]="formviewState.includeBlock.tiles.length"
                        (addBlockEmiiter)="addNewBlock('includeBlock', 'include', commonCommunicationService.empLimits, commonCommunicationService.payrollLimits, i)"
                        (formValues)="setUserInputs($event, tile)"
                        (invalidForm)="setFormInvalid(tile)"
                        (officerValid)="setOfficerValid($event)"
                        (close)="closeTile('includeBlock' , i, commonCommunicationService.empLimits, commonCommunicationService.payrollLimits )">
                      </app-emp-tile>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <!--*ngIf="entityTypeValues?.allowExclude"-->
          @if (entityTypeValues?.allowExclude && showOfficersCheckBox) {
            <div class="check-excludeOfficers">
              @if (isUserAgent) {
                <mat-checkbox [formControl]="excludeOfficers"
                  (change)="showBlock(excludeOfficers, 'exclude', commonCommunicationService.empLimits)">
                  I have Owners/Officers that will be <b>excluded</b> from the Workers Compensation policy.
                </mat-checkbox>
              }
              @if (!isUserAgent) {
                <mat-checkbox [formControl]="excludeOfficers"
                  (change)="showBlock(excludeOfficers, 'exclude', commonCommunicationService.empLimits)">
                  I have Owners/Officers that will be <b>excluded</b> from my Workers Compensation policy.
                </mat-checkbox>
              }
            </div>
          }
          @if (showCAInfo) {
            <div class="ca-waiver">
              <div class="cb-card cb-card--elevated">
                <div class="cb-card__content">
                  <p class="ca-waiver-title">{{labelDictionary.jobType.caWaiver.title}}</p>
                  <p class="ca-waiver-text">{{labelDictionary.jobType.caWaiver.note1}}</p>
                  <p class="ca-waiver-text">{{labelDictionary.jobType.caWaiver.note2}}
                    <br/><a (click)="downloadWaiverForm()" class="ca-waiver-text-bold">
                  {{labelDictionary.jobType.caWaiver.docLink}}</a>
                  <br/><br/>
                  {{labelDictionary.jobType.caWaiver.note3}}<br/>
                  <span
                  class="ca-waiver-text-bold">{{labelDictionary.jobType.caWaiver.email}}</span>
                  <br/><br/>
                  <span class="ca-waiver-text-desktop">{{labelDictionary.jobType.caWaiver.note4}}</span>
                  <span class="ca-waiver-text-mobile">{{labelDictionary.jobType.caWaiver.note4mobile}}
                    <a href='{{callUsNumber.phoneNumberLink}}' appAnalytics="click" eventCategory="JOB_TYPE"
                      eventAction="JOB_TYPE_CA_WAIVER" eventLabel="Call :{{callUsNumber.phoneNumber}}"
                    class="ca-waiver-phone-link">{{labelDictionary.jobType.caWaiver.call}}</a>.
                  </span>
                </p>
                <hr/><br/>
                <div class="ca-waiver-acknowledge">
                  <mat-checkbox class="ca-waiver-disclaimer"
                    [checked]="this.commonCommunicationService.caWaiverSectionChecked"
                    (change)="acceptCAViewer($event, commonCommunicationService.empLimits)">
                    {{labelDictionary.jobType.caWaiver.acknowledge}}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        }
        @if (formviewState?.excludeBlock?.isAdded) {
          <div>
            @for (tile of formviewState.excludeBlock.tiles; track tile; let i = $index) {
              <div class="tile-wrapper">
                @if (companyStructure && execTitles) {
                  <div>
                    <app-emp-tile [blockDetails]="tile" [type]="'exclude'" [companyStructure]="entityTypeValues.excludeEntities"
                      [state]="state" [errorMessages]="errorMessages" [id]="'exclude'+i" [viewIndex]="i"
                      [length]="formviewState.excludeBlock.tiles.length"
                      [isIncludeAdded]="formviewState.excludeBlock.isAdded"
                      (addBlockEmiiter)="addNewBlock('excludeBlock', 'exclude', commonCommunicationService.empLimits, commonCommunicationService.payrollLimits, i)"
                      (formValues)="setUserInputs($event, tile)"
                      (invalidForm)="setFormInvalid(tile)"
                      (officerValid)="setOfficerValid($event)"
                      (close)="closeTile('excludeBlock', i, commonCommunicationService.empLimits, commonCommunicationService.payrollLimits)">
                    </app-emp-tile>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <div class="formContainer">
        <div>
          @if (!isUserAgent) {
            <p class="title-job-type">Please select the job type, employment status and total salary for your <b>employee(s)</b>. The salary of the included owner/officer also needs to be added to employee payroll.
          </p>
        }
        @if (isUserAgent) {
          <p class="title-job-type">Please select the job type, employment status and total salary for applicant's <b>employee(s)</b>. The salary of the included owner/officer also needs to be added to employee payroll.
        </p>
      }
      @for (tile of formviewState.jobTypeBlock.tiles; track tile; let i = $index) {
        <div class="tile-wrapper">
          <app-emp-tile [blockDetails]="tile" [type]="'jobtype'" [jobTypeArray]="jobTypeArray" [companyStructure]="companyStructure.wcEntityName"
            [state]="state" [errorMessages]="errorMessages" [id]="'jobtype'+i" [viewIndex]="i"
            [length]="formviewState.jobTypeBlock.tiles.length"
            [jobtypes]="formviewState.jobTypeBlock"
            [isIncludeAdded]="true"
            (addBlockEmiiter)="addNewBlock('jobTypeBlock', 'jobtype', commonCommunicationService.empLimits, commonCommunicationService.payrollLimits, i)"
            [validateErrors]="tile.isInvalid"
            (formValues)="setUserInputs($event, tile)"
            (invalidForm)="setFormInvalid(tile)"
            (jobTypeValid)="setJobTypeValid($event)"
            (close)="closeTile('jobTypeBlock', i, commonCommunicationService.empLimits, commonCommunicationService.payrollLimits)">
          </app-emp-tile>
        </div>
      }
    </div>
  </div>
  <!-- <div class="location-totals">
  <h3 class="location-totals__title">Location totals</h3>
  <div class="location-totals__items">
    <div class="location-totals__items--fullTime">
      <p class="location-totals__items--text">Full-time employee count</p>
      <p class="location-totals__items--val">{{totalFullTimeEmpCount}}</p>
    </div>
    <div class="location-totals__items--partTime">
      <p class="location-totals__items--text">Part-time employee count</p>
      <p class="location-totals__items--val">{{totalPartTimeEmpCount}}</p>
    </div>
    <div class="location-totals__items--payroll">
      <p class="location-totals__items--text">Annual payroll</p>
      <p class="location-totals__items--val">{{totalPayrollAmt}}</p>
    </div>
  </div>
</div> -->
<hr class="hr-margin"/>
<br/>

@if (empLimitError && (commonCommunicationService?.empLimits?.totalEmployees < commonCommunicationService?.empLimits?.limitConsumed)) {
  <div class="error-text">Employee limit reached.</div>
}
@if (includeCheckError && excludeCheckError) {
  <div class="error-text">Please specify an owner or officer to include and/or exclude.</div>
}
@if (caWaiverError && excludeOfficers.value) {
  <div class="error-text">Please acknowledge the terms above.</div>
}
<div class="continue-btn">
  <div class="clearfix">
    <button (click)="validatePage(commonCommunicationService.empLimits)" class="continue-btn-btn wrk-btn">Continue</button>
  </div>
</div>

</div>
</section>
</div>
</div>
